<style>
table {
  counter-reset: rowNumber;
}

#sino::before {
  display: table-cell;
  counter-increment: rowNumber;
  content: counter(rowNumber);
  
}
</style>
<template>
<section class="vbox">
  <section class="scrollable padder">
    <section class="row m-b-md brud-theme">
      <div class="col-sm-6 text-black">
        <ol class="breadcrumb text-left">
          <li>
            <a href="#"><i class="fa fa-dashboard"></i> Home</a>
          </li>
          <li class="active">List of User</li>
        </ol>
      </div>
      <div class="col-sm-6 text-right text-left m-t-sm">
        <small>Welcome back </small>
      </div>
    </section>
    <section class="panel panel-default">
      <header class="panel-heading">
        <div class="row">
          <div class="col-md-12">
            <a v-on:click="editAdminUser(0)" class="btn btn-success pull-right">
              <i class="fa fa-plus"> </i> New User
            </a>

            <h4>
              <i class="fa fa-list-ul"></i>
              Search User
            </h4>
          </div>
        </div>
      </header>
      <div class="modal-body">
        <form @submit.prevent="searchUser()" method="post">
          <div class="row">
            
            <!-- <div class="col-lg-4">
              <div class="form-group">
                <label for="price"
                  >Tag <span class="required-color">*</span></label
                >
                <input
                  type="text"
                  name="tag_name"
                  autocomplete="off"
                  data-parsley-trigger="keyup"
                  data-parsley-type="text"
                  class="form-control"
                  id="price"
                  value=""
                  placeholder="Tag"
                />
              </div>
            </div> -->
            <div class="col-lg-4">
              <div class="form-group" style="padding-top: 25px;">
                <input type="hidden" name="type" value="" />
                <button type="submit" class="btn btn-success">
                  &nbsp;&nbsp;&nbsp; Search &nbsp;&nbsp;&nbsp;
                </button>
<!--                 <a class="btn btn-danger" href=""
                  >&nbsp;&nbsp;&nbsp;&nbsp; Reset &nbsp;&nbsp;&nbsp;&nbsp;</a
                > -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
    <section v-if="showUserList">
      <UserList  v-on:edit-admin-user="editAdminUser"  v-on:hide-tag="showUserList = false" />
    </section>
    <!-- <section v-if="showAddAdminUser">
      <AddAdminUser  v-on:hide-admin-user="showAddAdminUser = false" />
    </section> -->
    

      <panel-modal v-if="showAddAdminUser" class-list="col-md-6" @close="showAddAdminUser = false">
            <template #header>
              <h4>
                <i class="fa fa-list-ul"></i>
                Add / Edit Admin User
              </h4>
            </template>
            <template #body>
               <AddAdminUser :adminUserId="admin_user_id"  v-on:hide-admin-add-user="getadminUserList" />
            </template>
          </panel-modal>



  </section>
  </section>
</template>
<script>
//import axios from 'axios'
// import api from "../api";
import UserList from "../components/UserList.vue";
import AddAdminUser from "../components/AddAdminUser.vue";
import PanelModal from '../components/PanelModal.vue'
export default {
  name: "User",
  data() {
    return {
      showUserList: false,
      showAddAdminUser:false,
      admin_user_id:'',
    };
  },
  methods: {
    searchUser:function(){
      this.showUserList = true;
    },
    editAdminUser:function(adminUserId){
      this.admin_user_id = adminUserId
       this.showAddAdminUser = true;
    },
    addUser:function(){
      this.showAddAdminUser = true;
    },
    getadminUserList:function(){
      this.showAddAdminUser = false;
       this.showUserList = false;
    },
  },
  components: {
    UserList,
    AddAdminUser,
    PanelModal,
  },
};
</script>
